import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PedidosViewComponent } from './views/pedidos-view.component';
import { CrearPedidoComponent } from './components/crear-pedido/crear-pedido.component';

const routes: Routes = [
  {
    path: '',
    component: PedidosViewComponent,
    pathMatch: 'full',
  },
  {
    path: 'crear',
    component: CrearPedidoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PedidosRoutingModule {}
